import { useState, useEffect } from 'react';
import { api } from '../lib/api.js';
import { kioskApi } from '../lib/kiosk-api.js';

export function KioskLogin({ locationKey, onLogin }) {
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  function press(d) {
    setError('');
    setPin(p => p.length >= 4 ? p : p + d);
  }
  function back() { setError(''); setPin(p => p.slice(0, -1)); }

  async function submit() {
    if (pin.length !== 4) return;
    setBusy(true); setError('');
    try {
      const r = await kioskApi('POST', '/api/kiosk/login', { location_key: locationKey, pin });
      onLogin(r);
    } catch (e) {
      // Server returns plain-text error message — surface it.
      let msg = String(e.message || e);
      try { msg = JSON.parse(msg).error || msg; } catch {}
      setError(msg);
      setPin('');
    } finally { setBusy(false); }
  }

  // Auto-submit when 4 digits entered.
  useEffect(() => { if (pin.length === 4) submit(); }, [pin]);

  const dots = [0, 1, 2, 3].map(i => (
    <div key={i} style={{ width: 16, height: 16, borderRadius: '50%',
                           background: i < pin.length ? '#b48a47' : 'rgba(255,255,255,0.18)' }} />
  ));

  const keys = ['1','2','3','4','5','6','7','8','9','','0','⌫'];

  return (
    <div style={{ minHeight: '100vh', background: '#1c1f1d', color: '#fff', display: 'flex', flexDirection: 'column',
                   alignItems: 'center', justifyContent: 'center', padding: 'env(safe-area-inset-top, 0) 0 env(safe-area-inset-bottom, 0) 0', fontFamily: 'inherit' }}>
      <img src="/assets/monarch-icon-180.png" alt="" style={{ width: 60, height: 60, marginBottom: 12 }} />
      <div style={{ fontSize: 11, color: '#b48a47', textTransform: 'uppercase', letterSpacing: '0.2em', marginBottom: 4 }}>Empire Tea & Coffee</div>
      <div style={{ fontSize: 24, fontWeight: 700, marginBottom: 4 }}>Monarch Kiosk</div>
      <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', marginBottom: 28, textTransform: 'capitalize' }}>{locationKey.replace(/_/g, ' ')}</div>
      <div style={{ display: 'flex', gap: 14, marginBottom: 24 }}>{dots}</div>
      {error && <div style={{ fontSize: 13, color: '#fca5a5', marginBottom: 20 }}>{error}</div>}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 72px)', gap: 14 }}>
        {keys.map((k, i) => k === '' ? <div key={i} /> : (
          <button key={i} onClick={() => k === '⌫' ? back() : press(k)} disabled={busy}
            style={{ width: 72, height: 72, borderRadius: 36, fontSize: 28, fontWeight: 500,
                      background: 'rgba(255,255,255,0.08)', color: '#fff', border: 'none',
                      cursor: 'pointer', fontFamily: 'inherit',
                      WebkitTapHighlightColor: 'rgba(180,138,71,0.3)' }}>
            {k}
          </button>
        ))}
      </div>
      <div style={{ marginTop: 28, fontSize: 11, color: 'rgba(255,255,255,0.35)' }}>Enter your 4-digit PIN.</div>
    </div>
  );
}
